import { render, staticRenderFns } from "./ProductSummaryByOrder.vue?vue&type=template&id=447d535e"
import script from "./ProductSummaryByOrder.vue?vue&type=script&lang=js"
export * from "./ProductSummaryByOrder.vue?vue&type=script&lang=js"
import style0 from "./ProductSummaryByOrder.vue?vue&type=style&index=0&id=447d535e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports